/**
 * Who can do what on a parked PRA claim (F-CTRL-N66).
 *
 * Mirrors the backend route groups: POST /fiscal/pra/:id/resolve (the "found
 * in portal" declaration) is admin-only; POST /fiscal/pra/:id/resubmit
 * ("not in portal — resubmit", release + re-queue) rides fiscalRetry, which
 * admits admin and manager. Accountants read the worklist only. The card
 * hides what the role cannot do rather than let it hit a 403.
 */
export interface PraClaimActions {
  canDeclareFound: boolean
  canResubmit: boolean
}

export function praClaimActionsFor(role: string): PraClaimActions {
  switch (role) {
    case 'admin':
      return { canDeclareFound: true, canResubmit: true }
    case 'manager':
      return { canDeclareFound: false, canResubmit: true }
    default:
      return { canDeclareFound: false, canResubmit: false }
  }
}
